"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOOL_BAR_HOVER_MESSAGE = exports.SIDEBAR_INPUTS_MARGIN = exports.QUESTION_WIDTH = exports.QUESTION_HEIGHT = exports.MAX_LOAD_ATTEMPTS = exports.FONT_SIZE_FEEDBACK = exports.FIELD_NAME_FEEDBACK = exports.DEFAULT_PLACE_HOLDER_TEXT = exports.CLONE_ADDITIONAL_SPACE = exports.CHECKBOX_OPTION_NAME_FEEDBACK = exports.CHARACTER_SPACING_FEEDBACK = exports.ANSWER_WIDTH = exports.ANSWER_HEIGHT = exports.ACCORDION_LETTER_WEIGHT = exports.ACCORDION_LETTER_SPACING = void 0;
var QUESTION_WIDTH = exports.QUESTION_WIDTH = 20;
var QUESTION_HEIGHT = exports.QUESTION_HEIGHT = 2;
var ANSWER_WIDTH = exports.ANSWER_WIDTH = 2;
var ANSWER_HEIGHT = exports.ANSWER_HEIGHT = 1.5;
var FIELD_NAME_FEEDBACK = exports.FIELD_NAME_FEEDBACK = 'Please provide a valid field name.';
var FONT_SIZE_FEEDBACK = exports.FONT_SIZE_FEEDBACK = 'Please provide a valid font size.';
var CHARACTER_SPACING_FEEDBACK = exports.CHARACTER_SPACING_FEEDBACK = 'Please provide a valid character spacing.';
var CHECKBOX_OPTION_NAME_FEEDBACK = exports.CHECKBOX_OPTION_NAME_FEEDBACK = 'Please provide a valid checkbox option name.';
var CLONE_ADDITIONAL_SPACE = exports.CLONE_ADDITIONAL_SPACE = 4;
var MAX_LOAD_ATTEMPTS = exports.MAX_LOAD_ATTEMPTS = 5;
var TOOL_BAR_HOVER_MESSAGE = exports.TOOL_BAR_HOVER_MESSAGE = 'Click and drag';
var DEFAULT_PLACE_HOLDER_TEXT = exports.DEFAULT_PLACE_HOLDER_TEXT = 'Type Here';
var ACCORDION_LETTER_SPACING = exports.ACCORDION_LETTER_SPACING = '0.3px';
var ACCORDION_LETTER_WEIGHT = exports.ACCORDION_LETTER_WEIGHT = 400;
var SIDEBAR_INPUTS_MARGIN = exports.SIDEBAR_INPUTS_MARGIN = '8px';